module.exports = __webpack_public_path__ + "img/7dcae96.png";